import React, { Component, PropTypes } from 'react';
import _ from 'underscore';

import Button from '../elements/Button';
import TextInputGroup from '../elements/TextInputGroup';

class RegisterParentForm extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            schoolName: !_.isUndefined(props.selectedSchool) && !_.isNull(props.selectedSchool) ? props.selectedSchool.title : '',
            school_id: !_.isUndefined(props.selectedSchool) && !_.isNull(props.selectedSchool) ? props.selectedSchool.id : null,
            full_name: '',
            address_1: '',
            address_2: '',
            city: '',
            county: '',
            postcode: '',
            email: '',
            username: '',
            phone_number: '',
            password: '',
            agreeTerms: false,
        };
    }

    // componentDidUpdate() {
    //     if (!_.isNull(this.props.selectedSchool) && this.state.schoolName.length === 0) {
    //         this.setState({
    //             schoolName: this.props.selectedSchool.title
    //         });
    //     }
    // }

    handleSubmit = (e) => {
        e.preventDefault();

        const { schoolName } = this.state;

        if (!_.isNull(schoolName)) {
            this.props.handleSubmit({ data: this.state, type: 'parent' });
        }
    };

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <TextInputGroup
                    name="inviteCode"
                    label="Registering for school"
                    placeholder="School name"
                    value={this.state.schoolName}
                    onChange={e => this.setState({ schoolName: e.target.value })}
                    toolTip="We have auto selected this school based on the school invite code you provided" />
                <TextInputGroup
                    name="full_name"
                    label="Full name"
                    placeholder="Your full name"
                    value={this.state.full_name}
                    onChange={e => this.setState({ full_name: e.target.value })}
                    toolTip="E.g. John Doe" />
                <TextInputGroup
                    name="address_1"
                    label="Your address"
                    placeholder="First line"
                    value={this.state.address_1}
                    onChange={e => this.setState({ address_1: e.target.value })}
                    toolTip="Your home address. We may use this later to send you printed resources." />
                <TextInputGroup
                    name="address_2"
                    label={null}
                    placeholder="Second line"
                    value={this.state.address_2}
                    onChange={e => this.setState({ address_2: e.target.value })} />
                <TextInputGroup
                    name="city"
                    label={null}
                    placeholder="City"
                    value={this.state.city}
                    onChange={e => this.setState({ city: e.target.value })} />
                <TextInputGroup
                    name="county"
                    label={null}
                    placeholder="County"
                    value={this.state.county}
                    onChange={e => this.setState({ county: e.target.value })} />
                <TextInputGroup
                    name="postcode"
                    label={null}
                    placeholder="Postcode"
                    value={this.state.postcode}
                    onChange={e => this.setState({ postcode: e.target.value })} />
                <TextInputGroup
                    name="email"
                    label="Your email address"
                    placeholder="Your email address..."
                    value={this.state.email}
                    onChange={e => this.setState({ email: e.target.value, username: e.target.value })}
                    toolTip="E.g. jane.smith@schoolname.ac.uk" />
                <TextInputGroup
                    type="number"
                    name="phone_number"
                    label="Your phone number"
                    placeholder="Your phone number"
                    value={this.state.phone_number}
                    onChange={e => this.setState({ phone_number: e.target.value })}
                    toolTip="The best telephone number to reach you on in working hours." />
                <TextInputGroup
                    type="password"
                    name="password"
                    label="Password"
                    value={this.state.password}
                    onChange={e => this.setState({ password: e.target.value })}
                    toolTip="A strong password is at least 7 characters long and contains a number, capital and symbol." />
                <p>
                    <input
                        type="checkbox"
                        value={this.state.agreeTerms}
                        onChange={() => this.setState({ agreeTerms: !this.state.agreeTerms })} />
                    I agree to the Clever Tykes <a href="#">terms and conditions</a>
                </p>
                <p>
                    <Button>
                        <p>Submit</p>
                    </Button>
                </p>
            </form>
        );
    }
}

RegisterParentForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    selectedSchool: PropTypes.object
};

module.exports = RegisterParentForm;



/** WEBPACK FOOTER **
 ** ./src/forms/RegisterParentForm.js
 **/